var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"icon-container"},[_c('v-row',{staticClass:"ma-0"},[_c('v-icon',{attrs:{"small":"","color":_vm.iconColor}},[_vm._v(_vm._s(_vm.icon))]),_c('span',{staticClass:"ml-2"},[_vm._v(_vm._s(_vm.label))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }